import { render, staticRenderFns } from "./threeAds.vue?vue&type=template&id=34541888"
import script from "./threeAds.vue?vue&type=script&lang=js"
export * from "./threeAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports